// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_aVJCw","secondaryColumnCell":"secondary-column-cell_aVJCw","field":"field_Xy3i1","label":"label_wriYy"};